import { Box, Stack, Typography, useTheme } from "@mui/material";
import { FC } from "react";

interface IStatusColumn {
  status?: "CONNECTED" | "CONNECTING" | "DISCONNECTED" | "ERROR";
}

const StatusColumn: FC<IStatusColumn> = ({ status }) => {
  const theme = useTheme();

  if (!status) {
    return <Typography>-</Typography>;
  }

  const colors = {
    DISCONNECTED: theme.palette.warning.main,
    ERROR: theme.palette.error.main,
    CONNECTED: theme.palette.success.main,
    CONNECTING: theme.palette.success.main,
  };

  return (
    <Stack width="100%" justifyContent="center" alignItems="center">
      <Box sx={{ borderRadius: "50%", height: 18, width: 18, background: colors[status] ?? "inherit" }} />
    </Stack>
  );
};

export default StatusColumn;
